import * as React from 'react';
import { cn } from '../lib/utils';

interface FilterBarProps extends React.ComponentPropsWithoutRef<'div'> {
  actions?: React.ReactNode;
  fieldsClassName?: string;
  footer?: React.ReactNode;
  children?: React.ReactNode;
}

export function FilterBar({
  actions,
  fieldsClassName,
  footer,
  className,
  children,
  ...props
}: FilterBarProps) {
  return (
    <div
      className={cn(
        'rounded-lg bg-subtle p-[var(--space-panel)]',
        className
      )}
      {...props}
    >
      <div className="space-y-[var(--space-filter-bar)]">
        <div className="flex flex-col gap-[var(--space-filter-bar)] lg:flex-row lg:items-end lg:justify-between">
          <div
            className={cn(
              'grid flex-1 gap-[var(--space-filter-bar)] md:grid-cols-2 xl:grid-cols-4',
              fieldsClassName
            )}
          >
            {children}
          </div>
          {actions ? <div className="flex shrink-0 flex-wrap gap-3">{actions}</div> : null}
        </div>
        {footer ? (
          <div className="flex flex-wrap items-center gap-6 border-t border-border pt-[var(--space-filter-bar)]">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}
